import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const AccountGroupLoading = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      bg="bg"
      border="1px solid"
      borderColor="neutral.200"
      p="16"
      mb="16"
    >
      <Box display="flex" css="gap: 8px">
        <Shimmer height="20px" width="20px" />
        <Shimmer height="20px" width="20px" />
        <Shimmer height="20px" width="70px" />
      </Box>

      <Shimmer height="20px" width="100px" />
    </Box>
  );
};
